// extracted by mini-css-extract-plugin
module.exports = {"SaveButton":"PDFDownloadButton_SaveButton__akThW","Saving":"PDFDownloadButton_Saving__2zbh3","save":"PDFDownloadButton_save__3AYIG"};